<template>
  <v-container fluid>
    <v-layout class="d-flex justify-space-between">
      <div
        class="text-h4 font-weight-black primary--text text-spacing mx-2"
        color="blue"
      >
        สรุปยอดเผาเก็บขนและกำจัดประจำเดือน
      </div>
      <date-picker
        color="black"
        class="mb-1 custom-datepicker"
        style="width: 15%"
        :format="momentFormat"
        v-model="now_Date"
      ></date-picker>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        elevation="0"
        dark
        link
        @click="searchTransfer_All()"
      >
        <v-icon left>mdi-cloud-search</v-icon>ค้นหา
      </v-btn>
      <v-btn
        class="mx-2"
        color="primary"
        elevation="0"
        dark
        link
        @click="backToDashboard()"
      >
        <v-icon left>mdi-backburger</v-icon>ย้อนกลับ
      </v-btn>
    </v-layout>
    <v-divider class="my-2"></v-divider>
    <v-card class="my-5">
      <comTransferWasteAll :nowDate="now_Date" ref="TransferAll"/>
      <comTransferWasteCar :nowDate="now_Date" ref="TransferCar"/>
    </v-card>
  </v-container>
</template>
<script>
import comTransferWasteAll from "../../components/_tableReport/comTransfer_WasteAll";
import comTransferWasteCar from "../../components/_tableReport/comTransfer_WasteCar";
import moment from "moment";
import { mapMutations, mapGetters } from "vuex";
export default {
  components: {
    comTransferWasteAll,
    comTransferWasteCar,
  },
  data() {
    return {
      now_Date: new Date(),
      momentFormat: {
        // Date to String
        stringify: (date) => {
          return date
            ? moment(date).add(543, "year").locale("th").format("LL")
            : "";
        },
        // String to Date
        parse: (value) => {
          return value ? moment(value, "LL").toDate() : null;
        },
      },
    };
  },
  watch:{
     
  },
  computed:{

  },
  methods: {
    searchTransfer_All() {
        console.log(this.now_Date);
        this.$refs.TransferAll.search_TransferWasteAll(this.now_Date)
        //this.$refs.TransferCar.search_TransferWasteAll(this.now_Date)
    },
    backToDashboard() {
      this.$router.push({ path: "/Dashboard" });
    },
    
  },
};
</script>

<style scoped>
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.v-application .subtitle-1 {
  font-family: "Prompt", sans-serif !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
.text_div {
  margin-right: 20px;
  color: black;
  font-weight: bold;
}
.width_combo {
  max-width: 300px;
}
#map-container {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
.pac-target-input {
  border: #b1b1b1 solid 1px;
  max-width: 450px;
  padding: 5px;
  border-radius: 5px;
  text-indent: 10px;
}
</style>